module.exports = __webpack_public_path__ + "static/media/vegitables_76.830cab23.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_76.csv
// module id = 664
// module chunks = 0